import React from "react";
import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import S360WidgetContainer from "root/s360components/LearningJournal/S360WidgetContainer";
import ReportWidget from "root/s360components/Reports/ReportWidget";

const ReportsPage = ({rval, type, home}) =>
{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const menu = urlParams.get('menu')

    const isParent = type === 'parent' ;

    const teacherLinks = () =>
    {
        return (
            <S360WidgetContainer style={{minHeight: '500px'}}>
                <S360WidgetBlock title=''>
                    <BootstrapRow>
                        <BootstrapCol width={2}>
                            <ReportWidget heading='Learning Journal' iconClass='icon-learning' title='Only observations shared with parent.' reportPage='LearningJournal' imageName='journal.svg' page='form_eyfsReports_filter_n3_react' basePage={home} rval={rval} menu={menu}/>
                        </BootstrapCol>
                        <BootstrapCol width={2}>
                            <ReportWidget heading='All Observations' iconClass='icon-all-obs' title='All observations, including those not shared with parent.' reportPage='AllObservations' imageName='journal.svg' page='form_eyfsReports_filter_n3_react' basePage='eyfs_admin.php' rval={rval} menu={menu}/>
                        </BootstrapCol>
                        <BootstrapCol width={2}>
                            <ReportWidget heading='Observation Counts' iconClass='icon-obs-summary' title='Counts of observations made, by child/aspect' reportPage='ObsCount' imageName='progress.svg' page='form_eyfsReports_filter_n3' basePage='eyfs_admin.php' rval={rval} menu={menu}/>
                        </BootstrapCol>
                        <BootstrapCol width={2}>
                            <ReportWidget heading='Parent Observations' iconClass='icon-parent-observations' title='Observations created by parent/carers.' reportPage='ParentObservations' imageName='parent_obs.svg' page='form_eyfsReports_filter_n3_react' basePage='eyfs_admin.php' rval={rval} menu={menu}/>
                        </BootstrapCol>
                        <BootstrapCol width={2}>
                            <ReportWidget heading='Class Reflections (Yearbook)' iconClass='icon-reflections'  title='Class work and events throughout the year.' reportPage='ClassReflections' imageName='journal.svg' page='form_eyfsReports_filter_n3' basePage='eyfs_admin.php' rval={rval} menu={menu}/>
                        </BootstrapCol>
                        <BootstrapCol width={2}>
                            <ReportWidget heading='Curriculum Progress' iconClass='icon-progress-summary'  title ='Pupil progress for each area of the curriculum.' reportPage='ObsProgress' imageName='progress.svg' page='form_eyfsReports_filter_n3' basePage='eyfs_admin.php' rval={rval} menu={menu}/>
                        </BootstrapCol>
                    </BootstrapRow>
                </S360WidgetBlock>
            </S360WidgetContainer>
        )
    }

    const parentLinks = () =>
    {
        return (
            <S360WidgetContainer style={{minHeight: '500px'}}>
                <S360WidgetBlock title=''>
                    <BootstrapRow>
                        <BootstrapCol width={2}>
                            <ReportWidget heading='Learning Journal' iconClass='icon-learning'  title="Teacher's and your observations" reportPage='LearningJournalParent' imageName='journal.svg' page='form_eyfsReports_filter_n3_react' basePage='eyfs_admin.php' rval={rval} menu={menu}/>
                        </BootstrapCol>
                        <BootstrapCol width={2}>
                            <ReportWidget heading='Class Reflections' iconClass='icon-reflections' title='Class work and events throughout the year.' reportPage='ClassReflections' imageName='journal.svg' page='form_eyfsReports_filter_n3' basePage='eyfs_admin.php' rval={rval} menu={menu}/>
                        </BootstrapCol>
                    </BootstrapRow>
                </S360WidgetBlock>
            </S360WidgetContainer>
        )
    }
    return isParent ? parentLinks() : teacherLinks() ;
}

export default ReportsPage ;